//REGISTER
export const POST_REGISTER = "/users/register";

export const GET_API_KEY = "/users/login";
//LOGIN
export const POST_LOGIN = "/users/login";
export const POST_LOGIN_ADMIN = "/users/AdminLogin";
export const POST_JWT_LOGIN = "/post-jwt-login";

export const POST_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";
export const POST_PASSWORD_FORGET = "/users/forgotPassword";
export const POST_PASSWORD_RESET = "/users/passwordReset";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";

// Product
export const GET_PRODUCTS = "/products";
export const GET_HOT_PRODUCTS = "/products/hot";
export const GET_PRODUCTS_BY_ID = "/products/ById";
export const DELETE_PRODUCT = "/products";
export const ADD_NEW_PRODUCT = "/products";
export const UPDATE_PRODUCT = "/products";
// Product User Visibility (new endpoints)
export const GET_ASSIGNED_USERS = "/products/GetAssignedUsers";
export const ASSIGN_USERS = "/products/AssignUsers";
export const UNASSIGN_USER = "/products/UnassignUser";

// Orders
export const GET_ORDERS = "/orders/SupplierOrders";
export const GET_CUSTOMER_ORDERS = "/orders/admin";
export const ORDER_CHANGE_STATUS = "/orders/SupplierOrders/changeStatus";
export const ADD_NEW_ORDER = "/orders";
export const UPDATE_ORDER = "/orders";
export const DELETE_ORDER = "/orders";
export const CANCEL_SUPLIER_ORDER = "/orders/cancelSupplierOrder";
export const CANCEL_CUSTOMER_ORDER = "/orders/cancel";
export const PURCHASE_ORDER = "/orders/purchaseOrder";
export const ORDER_SHIPPED = "/orders/orderShipped";
export const OFFER_UNITS = "/orders/requestPurchaseMore";

// importFiles
export const GET_FILES = "/imports/admin/batches";
export const IMPORT_FILE = "/imports/admin/upload";
export const GET_IMPORTS = "/imports/admin";
export const UPDATE_ROW = "/imports/admin/updateRow";
export const UPDATE_STATUS = "/imports/admin/updatestatus";
export const DELETE_BATCH = "/imports/admin/batches";
export const UPLOAD_STOCKCHECK = "/imports/admin/UploadStockCheck";

export const GET_SUPPLIERS = "/suppliers";
export const SUPPLIERS = "/suppliers";

export const GET_SETTINGS = "/adminSettings";
export const UPDATE_SETTINGS = "/adminSettings";

export const USERS = "/users";
export const ADD_USER = "/users/AdminRegister";
export const EDIT_USER = "/users";

//RESTRICTED
export const RESTRICTED_BRANDS = "/restricted/brands";
export const RESTRICTED_MELTABLES = "/restricted/meltables";
export const RESTRICTED_ASINS = "/restricted/asins";

//SUBSCRIPTION FREQUENCIES
export const SUBSCRIPTION_FREQUENCIES = "/users/SubscriptionFrequencies";

//DASHBOARD
export const GET_WEEKLY_UPLAODED_BY_CHANNEL =
  "/reports/WeeklyUploadedProductsByChannel";
export const GET_WEEKLY_UPLAODED = "/reports/weeklyUploadedProducts";
export const GET_WEEKLY_NEW_SUPPLIERS = "/reports/weeklyNewSuppliers";
export const GET_WEEKLY_TOTAL_ORDER_AMOUNT =
  "/reports/weeklySupplierTotalAmounts";
export const GET_WEEKLY_REFUNDS = "/reports/weeklyRefunds";
export const GET_WEEKLY_TOTAL_PURCHASES = "/reports/WeeklyTotalMemberPurchases";

// Monthly dashboard endpoints (used when period > 58 days)
export const GET_MONTHLY_UPLOADED = "/reports/MonthlyUploadedProducts";
export const GET_MONTHLY_UPLOADED_BY_CHANNEL =
  "/reports/MonthlyUploadedProductsByChannel";
export const GET_MONTHLY_NEW_SUPPLIERS = "/reports/MonthlyNewSuppliers";
export const GET_MONTHLY_GENERAL_SUPPLIER_ORDER_COUNTS =
  "/reports/MonthlyGeneralSupplierOrderCounts";
export const GET_MONTHLY_GENERAL_CUSTOMER_ORDER_COUNTS =
  "/reports/MonthlyGeneralCustomerOrderCounts";
export const GET_MONTHLY_REFUNDS = "/reports/MonthlyRefunds";
export const GET_MONTHLY_PROFITABLE_PRODUCTS =
  "/reports/MonthlyProfitableProducts";

export const GET_USER_STATS = "/reports/userStats";
export const GET_USER_STATS_RANGE = "/reports/UserStatsRange";
export const GET_USERS_STATS_BY_RANGE = "/reports/UsersStatsByRange";
export const GET_TOTAL_SUPPLIER_CANCELLED_ORDERS =
  "/reports/WeeklyTotalSupplierCancelledOrders";
export const GET_TOTAL_CUSTOMER_CANCELLED_ORDERS =
  "reports/WeeklyTotalCustomerCancelledOrders";
export const GET_SUBSCRIPTION_STATS = "/reports/subscriptionStats";

export const GET_TOP_MEMBERS_PURCHASES = "/reports/topMembersPurchases";
export const GET_TOP_PRODUCT_MARGINS = "/reports/topProductMargins";
export const GET_TOP_SELLERS = "/reports/TopSellerProducts";
export const GET_TOP_SELLER_SUPPLIERS = "/reports/TopSellerSuppliers";
export const GET_TOP_SELLER_CATEGORIES = "/reports/TopSellerCategories";
export const GET_TOP_SELLER_BRANDS = "/reports/TopSellerBrands";
export const GET_TOP_SELLER_ASINS = "/reports/TopSellerAsins";

export const GET_WEEKLY_GENERAL_SUPPLIER_ORDER_COUNTS =
  "/reports/WeeklyGeneralSupplierOrderCounts";
export const GET_GENERAL_SUPPLIER_ORDER_COUNTS =
  "/reports/GeneralSupplierOrderCounts";
export const GET_WEEKLY_GENERAL_CUSTOMER_ORDER_COUNTS =
  "/reports/WeeklyGeneralCustomerOrderCounts";
export const GET_INVENTORY_HISTORY = "/reports/inventoryHistory";
export const GET_WEEKLY_PROFITABLE_PRODUCTS = "/reports/WeeklyProfitableProducts";

export const GET_SUBSCRIPTIONS = "stripe/getSubscriptions";
